export enum ULDTypeEnum {
  AKE = "AKE",
  MDP = "MDP",
  LDP = "LDP",
}
